import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject, Observable } from "rxjs";
import { IPortalNavigation, IUserPortalFeatures, IPortalConfig, Tools, ITimeZone } from 'src/app/models';

@Injectable({ providedIn: 'root' })
export class PortalService {

  private portalDisplayNameSubject = new Subject<string>();
  private showPortalSectionSubject = new BehaviorSubject<boolean>(false);
  private showPortalSearchSubject = new Subject<boolean>();
  private toolsMenuSubject = new Subject<Array<Tools>>();
  private navigationMenuSubject = new BehaviorSubject<Array<IPortalNavigation>>([]);
  private allUserPortalFeaturesSubject = new Subject<Array<IUserPortalFeatures>>();
  private portalConfigSubject = new Subject<IPortalConfig>();
  allUserPortalFeatures: BehaviorSubject<Array<IUserPortalFeatures>> = new BehaviorSubject<Array<IUserPortalFeatures>>([]);
  portalConfiguation: BehaviorSubject<IPortalConfig> = new BehaviorSubject<IPortalConfig>({});
  private userPortalsSubject = new Subject<Array<IPortalNavigation>>();
  allUserPortals: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  private globalPortalConfigSubject = new Subject<IPortalConfig>;
  globalPortalConfiguration: BehaviorSubject<IPortalConfig> = new BehaviorSubject<IPortalConfig>(null!);
  isRaiLayout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  raiNavCollapsed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }
  updateTimeZone(timeZone: ITimeZone) {    
    this.portalConfiguation.value.TimeZone = {
      DayLightName: timeZone.DayLightName,
      Description: timeZone.Description,
      IANATimeZoneName: timeZone.IANATimeZoneName,
      Offset: timeZone.Offset,
      StandardName: timeZone.StandardName,
      TimeZoneId: timeZone.TimeZoneId,
      TimeZoneName: timeZone.TimeZoneName
    };
  }
  setPortalDisplayName(title: string) {
    this.portalDisplayNameSubject.next(title);
  }

  getPortalDisplayName(): Observable<string> {
    return this.portalDisplayNameSubject.asObservable();
  }

  setShowPortalSection(showPortalSection: boolean) {
    this.showPortalSectionSubject.next(showPortalSection);
  }

  getShowPortalSection(): Observable<boolean>{
    return this.showPortalSectionSubject.asObservable();
  }

  setShowPortalSearch(showPortalSearch: boolean) {
    this.showPortalSearchSubject.next(showPortalSearch);
  }

  getShowPortalSearch(): Observable<boolean> {
    return this.showPortalSearchSubject.asObservable();
  }

  setToolsMenuSubject(tools: Array<Tools>) {
    this.toolsMenuSubject.next(tools);
  }

  getToolsMenuSubject(): Observable<Array<Tools>> {
    return this.toolsMenuSubject.asObservable();
  }

  setNavigationMenuSubject(navigation: Array<IPortalNavigation>) {
    this.navigationMenuSubject.next(navigation);
  }

  getNavigationMenuSubject(): Observable<Array<IPortalNavigation>> {
    return this.navigationMenuSubject.asObservable();
  }

  setAllFeaturesSubject(allFeatures: Array<IUserPortalFeatures>) {
    this.allUserPortalFeatures.next(allFeatures);
    this.allUserPortalFeaturesSubject.next(allFeatures);
  }

  getAllFeaturesSubject(): Observable<Array<IUserPortalFeatures>> {
    return this.allUserPortalFeaturesSubject.asObservable();
  }

  setPortalConfigSubject(config: IPortalConfig) {
    this.portalConfiguation.next(config);
    this.portalConfigSubject.next(config);
  }

  getPortalConfigSubject(): Observable<IPortalConfig> {
    return this.portalConfigSubject.asObservable();
  }

  setUserPortalsSubject(portals: Array<any>) {
    this.allUserPortals.next(portals);
    this.userPortalsSubject.next(portals);
  }

  getUserPortalsSubject(): Observable<Array<any>> {
    return this.userPortalsSubject.asObservable();
  }

  setGlobalPortalConfigSubject(config: IPortalConfig) {
    this.globalPortalConfiguration.next(config);
    this.globalPortalConfigSubject.next(config);
  }

  getGlobalPortalConfigSubject(): Observable<IPortalConfig> {
    return this.globalPortalConfigSubject.asObservable();
  }

  setIsRaiLayout(isRaiLayout: boolean) {
    this.isRaiLayout.next(isRaiLayout);
  }

  getIsRaiLayout(): Observable<boolean> {
    return this.isRaiLayout.asObservable();
  }

  setRaiNavCollapsed(collapsed: boolean) {
    this.raiNavCollapsed.next(collapsed);
  }

  getRaiNavCollapsed(): Observable<boolean> {
    return this.raiNavCollapsed.asObservable();
  }
}
